import Actions                  from 'Redux/Actions';
import { EventRepository }      from 'Domain/Repositories';
import { ofType }               from 'redux-observable';
import { from }                 from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';
import { TEpic }                from 'Redux/Config';
import { message }              from 'antd';

export const cancelEventEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.cancelEventRequest.type),
    mergeMap(action => from(EventRepository.cancelEvent(action.payload.id))
      .pipe(
        mergeMap((event) => {
          message.success('Das Event wurde erfolgreich abgesagt.');

          return from([
            Actions.cancelEventSuccess({ event }),
          ]);
        }),
        catchError(error => {
          return from([
            Actions.cancelEventFailure({ error })
          ]);
        })
      )
    ),
  );
};
